<template>

  <b-dropdown-item v-if="isSubItem" v-on:click="downloadManual" right>
    <span class="text-warning">
      <font-awesome-icon icon="question" class="text-warning" />
      {{ $t('Webportal.Guideline') }}
    </span>
  </b-dropdown-item>

  <b-nav-item v-else v-on:click="downloadManual" right>
    <span class="nav-large text-warning">
      <font-awesome-icon icon="question" class="text-warning" />
      {{ $t('Webportal.Guideline') }}
    </span>
    <span class="nav-small text-warning"
          v-b-tooltip.hover.nofade="toolTipDelay" :title="$t('Webportal.Guideline')">
      <font-awesome-icon icon="question" class="text-warning" />
    </span>
  </b-nav-item>

</template>

<script>

import DownloadFileMixin from '@/mixins/DownloadFileMixin'
import DashboardService from '@/services/DashboardService-APP_TARGET'
import AppConfig from '@/mixins/AppConfig-APP_TARGET';

export default {
  name: "ManualDownload",

  props: {
    isSubItem: { type: Boolean, default: false }
  },

  mixins: [ DownloadFileMixin, AppConfig ],

  methods: {
    downloadManual() {
        DashboardService.getApplicationManual(null, window.location.hostname)
          .then(response => {
            this.downloadFile(response);
          });
    }
  }
}

</script>
